import React, { useReducer } from 'react';
import DashboardContext from './dashboardContext';
import dashboardReducer from './dashboardReducer';

import clienteAxios from '../../service/axios';

import {
    OBTENER_DASHBOARD,
    MARCA_ERROR,
    MARCA_OK
} from 'types/context';

const DashboardState = props => {
    const initialState = {
        widgets: [],
        mensaje: null
    }

    const [state, dispatch] = useReducer(dashboardReducer, initialState);
    const obtenerDashboard = async (clienteId) => {
        try {
            // siempre deberia venir un cliente
            let resultado = await clienteAxios.get(`/dashboard/${clienteId}`);
            //console.log("context =>",resultado);

            //console.log("tempArr =>",tempArr)
            dispatch({
                type: OBTENER_DASHBOARD,
                payload: resultado.data.widgets || []
            });

            return resultado.data.widgets || []
        } catch (error) {
            dispatch({
                type: OBTENER_DASHBOARD,
                payload: []
            });
            const alerta = {
                msg: "error.response.data.message",
                categoria: 'error'
            }
            
            dispatch({
                type: MARCA_ERROR,
                payload: alerta
            })
            return  []
        }
    }

    // muestra un error de validacion
    const errorMarca = (msj, categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }
        dispatch({
            type: MARCA_ERROR,
            payload: alerta
        })
    }
    const OkMarca = (msj, categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }
        dispatch({
            type: MARCA_OK,
            payload: alerta
        })
    }
    const clearErrorMarca = () => {
        dispatch({
            type: MARCA_ERROR,
            payload: null,
        });
    };

    const clearOkMarca = () => {
        dispatch({
            type: MARCA_OK,
            payload: null,
        });
    };


    return (
        <DashboardContext.Provider
            value={{
                widgets: state.widgets,
                mensaje: state.mensaje,
                obtenerDashboard,
                clearErrorMarca,
                clearOkMarca,
                errorMarca,
                OkMarca,
            }}
        >{props.children}

        </DashboardContext.Provider>
    )
}
export default DashboardState;